<template>
  <div class="feixe_frozen" style="display: none;">
    <div class="row">
      <h5 class="disparador" data-disparador="conteudo_feixe_frozen">
        Propriedades de Frozen Wave
        <i class="material-icons">arrow_drop_down</i>
      </h5>
    </div>
    <div class="conteudo" id="conteudo_feixe_frozen">
      <div class="form-group">
        <label for="exampleInputEmail1">Q:</label>
        <input
          type="number"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder
        />
        <small id="emailHelp" class="form-text text-muted">Informações para o campo.</small>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">L:</label>
        <input
          type="number"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder
        />
        <small id="emailHelp" class="form-text text-muted">Informações para o campo.</small>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">N:</label>
        <input
          type="number"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder
        />
        <small id="emailHelp" class="form-text text-muted">Informações para o campo.</small>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Zmin:</label>
        <input
          type="number"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder
        />
        <small id="emailHelp" class="form-text text-muted">Informações para o campo.</small>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Zmax:</label>
        <input
          type="number"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder
        />
        <small id="emailHelp" class="form-text text-muted">Informações para o campo.</small>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">F(z):</label>
        <select class="form-control" id="input_type">
          <option>Constante</option>
          <option>Exponencial</option>
          <option>Outros</option>
        </select>
        <small id="emailHelp" class="form-text text-muted">Informações para o campo.</small>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "frozenWave"
};
</script>